import React, { useState, useEffect } from "react";
import MessageBubble from "./MessageBubble";
import Form from "./Form";
import DataList from "./DataList";
import DynamicTable from "../../../reuse_components/DynamicTable";
import CustomPagination from "../../../subComponents/pagination/CustomPagination";
import Confirmation from "./Confirmation";

const MessageTransformer = ({ msg, index, onSubmitInputs, onRetry }) => {
  const [response, setResponse] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5); // Default items per page

  useEffect(() => {
    if (msg.content && msg.role !== "user") {
      try {
        setResponse(JSON.parse(msg.content));
      } catch (error) {
        console.error("Invalid JSON response:", error);
        setResponse({
          response: msg.content,
          is_table: false,
          is_select: false,
        });
      }
    }
  }, [msg.content]);

  if (msg.role === "user") {
    return <MessageBubble msg={msg.content} role={msg.role} key={index} />;
  }
  if (msg.isError) {
    return (
      <MessageBubble
        msg={msg.content}
        role={msg.role}
        key={index}
        isError={msg.isError}
        onRetry={onRetry}
      />
    );
  }

  if (!response) return null;
  // Handle table pagination logic
  const tableData = response.is_table ? response.table.data : [];
  const totalItems = tableData.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  // Slice data for current page
  const paginatedData = tableData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <>
      <MessageBubble
        msg={response.response}
        role={msg.role}
        key={index}
        data={
          <>
            {response.need_input && (
              <Form
                fieldsConfig={response.input_fields}
                onSubmit={onSubmitInputs}
              />
            )}
            {response.is_table && (
              <>
                <DynamicTable
                  data={paginatedData}
                  columns={response.table.columns}
                />
                <CustomPagination
                  currentPage={currentPage}
                  totalItems={totalItems}
                  itemsPerPage={itemsPerPage}
                  totalPages={totalPages}
                  onPageChange={(page) => setCurrentPage(page)}
                />
              </>
            )}
            {response.is_list && (
              <DataList
                title={response.list.title}
                items={response.list.items}
              />
            )}
            {response.is_confirmation && (
              <Confirmation data={response.confirmation} />
            )}
          </>
        }
      />
    </>
  );
};

export default MessageTransformer;
